import { Data, TransformsList } from 'cio/utils/analytics/transforms';
import { NAMES } from 'cio/utils/ad-audiences';

type AdNetworkType = 'adwords' | 'facebook';

const Transforms: TransformsList = {
  base(data: Data & { type: AdNetworkType }) {
    return {
      'Ad Network': NAMES[data.type],
      'Starting Point': data.startingPoint,
    };
  },
};

export default Transforms;
